import BaseActionModal from "@/components/shared/dialogs/base-action-modal/base-action-modal";
import { Button } from "@/components/ui/button";

export interface ConfirmationModalProps {
  description: string;
  isPrimaryDisabled: boolean;
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
  primaryLabel: string;
  secondaryLabel: string;
  title: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  description,
  isPrimaryDisabled,
  onPrimaryClick,
  onSecondaryClick,
  primaryLabel,
  secondaryLabel,
  title,
}) => {
  return (
    <BaseActionModal.Root onClose={onSecondaryClick}>
      <BaseActionModal.Header className="flex items-baseline">
        {title}
      </BaseActionModal.Header>
      <BaseActionModal.Description className="flex text-left pt-0">
        {description}
      </BaseActionModal.Description>
      <BaseActionModal.Footer className="flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Button variant="outline" size="lg" onClick={onSecondaryClick}>
          {secondaryLabel}
        </Button>
        <Button
          variant="destructive"
          size="lg"
          onClick={onPrimaryClick}
          disabled={isPrimaryDisabled}
        >
          {primaryLabel}
        </Button>
      </BaseActionModal.Footer>
    </BaseActionModal.Root>
  );
};
